/* tslint:disable */

declare var Object: any;
export interface ScheduleInterface {
  "id": string;
  "ScheduleName": string;
  "Description"?: string;
  "ScheduleData": any;
  "NumberOfScreens": number;
  "RunTime": number;
  "TotalSizeInBytes": number;
  "Metadata"?: any;
  "Categories"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
}

export class Schedule implements ScheduleInterface {
  "id": string;
  "ScheduleName": string;
  "Description": string;
  "ScheduleData": any;
  "NumberOfScreens": number;
  "RunTime": number;
  "TotalSizeInBytes": number;
  "Metadata": any;
  "Categories": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: ScheduleInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Schedule`.
   */
  public static getModelName() {
    return "Schedule";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Schedule for dynamic purposes.
  **/
  public static factory(data: ScheduleInterface): Schedule{
    return new Schedule(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Schedule',
      plural: 'Schedules',
      path: 'Schedules',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "ScheduleName": {
          name: 'ScheduleName',
          type: 'string'
        },
        "Description": {
          name: 'Description',
          type: 'string'
        },
        "ScheduleData": {
          name: 'ScheduleData',
          type: 'any'
        },
        "NumberOfScreens": {
          name: 'NumberOfScreens',
          type: 'number',
          default: 0
        },
        "RunTime": {
          name: 'RunTime',
          type: 'number',
          default: 0
        },
        "TotalSizeInBytes": {
          name: 'TotalSizeInBytes',
          type: 'number',
          default: 0
        },
        "Metadata": {
          name: 'Metadata',
          type: 'any'
        },
        "Categories": {
          name: 'Categories',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Schedule.ts